// extracted by mini-css-extract-plugin
export default {"zigzag":"zigzag_oMmm"};